import Styled from 'styled-components';

export default Styled.div`
  --gradientA: rgba(62,166,176,0.1);
  --gradientB: rgba(124,205,184,0.1);
  --chevron: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNiAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1IDEuMjVMOCA4LjI1TDEgMS4yNSIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTE1IDEuMjVMOCA4LjI1TDEgMS4yNSIgc3Ryb2tlPSIjMjk5RTgzIiBzdHJva2Utd2lkdGg9IjEuODY2NjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=);
  --br-color: #178EAB;
  --other-color: #2E99B3;
  .accordion {
    .accordion-item {
        &:has([aria-expanded="true"]) {
          border-bottom-left-radius: 22px;
          border-bottom-right-radius: 22px;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;
        }
        .accordion-button {
          border-top-right-radius: 0.375rem;
          border-top-left-radius: 0.375rem;
          height: 90px;
          padding: 16px 34px 16px 24px;
          outline: none;
          background: linear-gradient(180deg, var(--gradientA) 0%,  var(--gradientB) 100%);
          &:after {
            width: 32px;
            height: 32px;
            padding: 10px;
            background-color: #FFFFFF;
            border-radius: 50%;
            background-image: var(--chevron);
            background-position-x: 50%;
            background-position-y: 55%;
            background-size: 16px 10px
          }
          &:focus {
            box-shadow: none;
          }
          &[aria-expanded="true"] {
            border-top: 1px solid var(--br-color);
            border-left: 1px solid var(--br-color);
            border-right: 1px solid var(--br-color);
          }
          .report_header {
            display: flex;
            .report_progress {
              margin-right: 16px;
            }
            .report_title {
              .report_status_wrapper {
                margin-top: 5px;
                .report_status {
                  font-family: 'Mulish';
                  font-size: 18px;
                  font-weight: 400;
                  line-height: 22.59px;
                  color: ${(props) => props?.theme?.text?.dark};
                  & span {
                    font-weight: 700;
                  }
                }
                .report_count {
                    margin-top: 6px;
                    span{
                    font-family: 'Mulish';
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 16.32px;
                    color: var(--other-color);
                    }
                    .divider {
                      border: 0.5px solid var(--other-color);
                      height: 16px;
                      margin: 0 6px;
                    }
                }
              }
            }
          }
        }
        .accordion-collapse {
          border: 1px solid var(--br-color);
          border-bottom-left-radius: 22px;
          border-bottom-right-radius: 22px;
        }  
        .accordion-body{
          padding: 0
        }
    }
  }

  @media (max-width: 425px) {
    .accordion {
      .accordion-item {
          .accordion-button {
            padding: 16px 16px 16px 24px;
            .report-header{
              .report-progress{
                margin-top:20px !important;
              }
            }
          }
      } 
    }    
  }

  @media (max-width: 320px){
    .accordion{
      .accordion-item{
        .accordion-button{
          .report_header{
            .report_title {
              .report_status_wrapper{
                .report_count{
                  margin-top: 0px;
                }
              } 
            }
            .report_progress {
              margin-right: 16px;
              margin-top:20px;
            }
          } 
        } 
      } 
    } 
  }
`;
